import { TableCell as HeroUiTableCell } from '@heroui/table';

export const TableCell = HeroUiTableCell;
